import { takeLatest } from 'redux-saga/effects';
import {
  GET_SYNERGY_COVERAGE_QUESTIONS,
  MOBILITY_CONTINUATION_GET_LOCATION_BY_COORDS,
  MOBILITY_CONTINUATION_GET_OPTION_LOCATION,
  MOBILITY_CONTINUATION_GET_PRODUCT_ID_AND_DISTANCE,
  MOBILITY_CONTINUATION_GET_SUGGESTIONS,
  REMOVE_SYNERGY_LAST_COVERAGE_QUESTION,
  SET_SYNERGY_COVERAGE_QUESTION_RESPONSE,
} from 'redux/actions/types';
import {
  getCoverageQuestions,
  goToPreviousQuestion,
  setCoverageAnswer,
} from './coverage-questions-saga';
import {
  getLocationByCoordinates,
  getLocationByPlaceId,
  getLocationByQuery,
  getProductIdAndDistanceSaga,
} from './mobility-continuation-saga';

export default function* mobilityContinuationSaga() {
  yield takeLatest(GET_SYNERGY_COVERAGE_QUESTIONS, getCoverageQuestions);
  yield takeLatest(SET_SYNERGY_COVERAGE_QUESTION_RESPONSE, setCoverageAnswer);
  yield takeLatest(REMOVE_SYNERGY_LAST_COVERAGE_QUESTION, goToPreviousQuestion);
  yield takeLatest(MOBILITY_CONTINUATION_GET_SUGGESTIONS, getLocationByQuery);
  yield takeLatest(
    MOBILITY_CONTINUATION_GET_LOCATION_BY_COORDS,
    getLocationByCoordinates,
  );
  yield takeLatest(
    MOBILITY_CONTINUATION_GET_OPTION_LOCATION,
    getLocationByPlaceId,
  );
  yield takeLatest(
    MOBILITY_CONTINUATION_GET_PRODUCT_ID_AND_DISTANCE,
    getProductIdAndDistanceSaga,
  );
}
